import React, { useState } from "react";
import { Share, X } from "lucide-react";

const DISMISS_KEY = "spark_ios_install_dismissed";

function shouldShow() {
  try {
    if (localStorage.getItem(DISMISS_KEY)) return false;
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isOtherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
    const standalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;
    return isIOS && !isOtherBrowser && !standalone;
  } catch {
    return false;
  }
}

export const IOSInstallBanner = () => {
  const [visible, setVisible] = useState(shouldShow);
  if (!visible) return null;
  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* ignore */ }
  };
  return (
    <div
      className="fixed bottom-3 left-3 right-3 z-[70] max-w-md mx-auto rounded-2xl bg-[#1E1F23] border border-[#C9A961]/30 shadow-2xl shadow-black/50 backdrop-blur-md"
      data-testid="ios-install-banner"
    >
      <div className="flex items-center gap-3 p-3.5">
        <div className="w-10 h-10 rounded-xl bg-[#C9A961]/12 border border-[#C9A961]/30 flex items-center justify-center shrink-0">
          <Share className="w-4.5 h-4.5 text-[#C9A961]" strokeWidth={2.2} />
        </div>
        <div className="flex-1 min-w-0 text-[13px] text-[#F0E6D2] leading-snug">
          <span className="font-display font-medium">Install Spark</span>
          <span className="text-[#A0A0A8]"> — tap Share </span>
          <span aria-hidden="true">⎙</span>
          <span className="text-[#A0A0A8]"> then </span>
          <span className="text-[#C9A961]">Add to Home Screen</span>
        </div>
        <button
          onClick={dismiss}
          className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-[#8C867C] hover:text-[#F0E6D2] hover:bg-white/[0.06] transition"
          aria-label="Dismiss"
          data-testid="ios-install-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
